import { render, staticRenderFns } from "./App.vue?vue&type=template&id=08f2e0ac&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=08f2e0ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f2e0ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\swag\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f2e0ac')) {
      api.createRecord('08f2e0ac', component.options)
    } else {
      api.reload('08f2e0ac', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=08f2e0ac&scoped=true&", function () {
      api.rerender('08f2e0ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Swag/App.vue"
export default component.exports